(() => {
  const root = document.querySelector("[data-sqmcalc]");
  if (!root) return;

  const moneyFormat = (root.dataset.moneyFormat || "").toString();

  // Variant price is PER BOX
  const pricePerBoxCents = parseInt(root.dataset.pricePerBoxCents || "0", 10);
  const sqmPerBox = parseFloat(root.dataset.sqmPerBox || "0");

  const areaInput = root.querySelector("[data-area]");
  const wasteInput = root.querySelector("[data-waste]");
  const summary = root.querySelector("[data-summary]");
  const warn = root.querySelector("[data-warn]");

  const boxesEl = root.querySelector("[data-boxes]");
  const boxWordEl = root.querySelector("[data-box-word]");
  const areaSuppliedEl = root.querySelector("[data-area-supplied]");
  const totalPriceEl = root.querySelector("[data-total-price]");
  const pricePerBoxEl = root.querySelector("[data-price-per-box]");

  // ✅ NEW: show ₹/m² in UI
  const pricePerSqmEl = root.querySelector("[data-price-per-sqm]");

  const tilesPerBoxUi = root.querySelector("[data-tiles-per-box-ui]");

  function formatMoneyCents(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {}

    const amount = (cents / 100).toFixed(2);
    const symbol =
      moneyFormat.includes("£") ? "£" :
      moneyFormat.includes("€") ? "€" :
      moneyFormat.includes("$") ? "$" : "";
    return symbol + amount;
  }

  // ✅ NEW: compute & set price per m²
  function setPricePerSqm() {
    if (!pricePerSqmEl) return;

    if (!Number.isFinite(sqmPerBox) || sqmPerBox <= 0 || pricePerBoxCents <= 0) {
      pricePerSqmEl.textContent = "—";
      return;
    }

    const centsPerSqm = Math.round(pricePerBoxCents / sqmPerBox);
    pricePerSqmEl.textContent = formatMoneyCents(centsPerSqm);
  }

  function findQtyInputs() {
    const list = [];
    document.querySelectorAll('input[name="quantity"]').forEach(el => list.push(el));
    const q1 = document.querySelector("#Quantity");
    if (q1) list.push(q1);
    document.querySelectorAll('input[id^="Quantity"]').forEach(el => list.push(el));
    return Array.from(new Set(list));
  }

  function setQuantity(qtyNumber) {
    const qtyInputs = findQtyInputs();
    if (!qtyInputs.length) return;

    qtyInputs.forEach(inp => {
      inp.value = String(qtyNumber);
      inp.dispatchEvent(new Event("input", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function pluralizeBox(n) {
    if (!boxWordEl) return;
    boxWordEl.textContent = n === 1 ? "box" : "boxes";
  }

  function update() {
    if (tilesPerBoxUi) {
      const v = (tilesPerBoxUi.textContent || "").trim();
      if (!v || v === "0") tilesPerBoxUi.textContent = "—";
    }

    if (!Number.isFinite(sqmPerBox) || sqmPerBox <= 0) {
      if (summary) summary.style.display = "none";
      if (warn) warn.style.display = "block";
      if (pricePerBoxEl) pricePerBoxEl.textContent = "—";
      if (pricePerSqmEl) pricePerSqmEl.textContent = "—";
      return;
    } else {
      if (warn) warn.style.display = "none";
    }

    if (pricePerBoxEl) {
      pricePerBoxEl.textContent =
        pricePerBoxCents > 0 ? formatMoneyCents(pricePerBoxCents) : "—";
    }

    // ✅ NEW: show price per m² always (when sqmPerBox exists)
    setPricePerSqm();

    const area = parseFloat(areaInput?.value || "0");
    if (!Number.isFinite(area) || area <= 0) {
      if (summary) summary.style.display = "none";
      return;
    }

    const needsWaste = wasteInput?.checked ? 1.1 : 1.0;
    const neededArea = area * needsWaste;

    const boxes = Math.max(1, Math.ceil(neededArea / sqmPerBox));
    const areaSupplied = boxes * sqmPerBox;

    if (boxesEl) boxesEl.textContent = String(boxes);
    pluralizeBox(boxes);

    if (areaSuppliedEl) areaSuppliedEl.textContent = areaSupplied.toFixed(2);

    const totalCents = boxes * (pricePerBoxCents > 0 ? pricePerBoxCents : 0);
    if (totalPriceEl) totalPriceEl.textContent = totalCents > 0 ? formatMoneyCents(totalCents) : "—";

    if (summary) summary.style.display = "block";

    setQuantity(boxes);
  }

  areaInput?.addEventListener("input", update);
  wasteInput?.addEventListener("change", update);

  let tries = 0;
  const timer = setInterval(() => {
    tries++;
    update();
    if (findQtyInputs().length || tries > 30) clearInterval(timer);
  }, 250);
})();
